import NewUserFormModal from './NewUserFormModal.container';

export default NewUserFormModal;
